/**
 * House of Places — Print / Framed Print / Canvas tabs on the product page.
 *
 * Reference (3) shows these above the size picker and reveals the frame list
 * only while a framed type is selected. The store has no "Type" option, so the
 * tabs group the FRAME OPTIONS values instead: each frame card carries a
 * data-hop-frame-type of plain / framed / canvas, and a tab simply picks the
 * first card in its group.
 *
 * Selecting a card is done by clicking its real radio input, so Dawn's own
 * variant machinery updates the price, the URL and the gallery exactly as it
 * would if the shopper had clicked the card. Nothing here duplicates that.
 *
 * Dawn re-renders the picker on every variant change, so this binds on the
 * document and re-reads state each time rather than holding references.
 */
(function () {
  // Dawn's quick-add modal re-runs every script inside <product-info> each
  // time it opens; bind once per page so no listener fires twice.
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-type-tabs']) return;
  yuklu['hop-type-tabs'] = true;

  function kartlar(kap) {
    return Array.prototype.slice.call(kap.querySelectorAll('[data-hop-frame-type]'));
  }

  function seciliTip(kap) {
    var secili = kap.querySelector('[data-hop-frame-type] input:checked');
    return secili ? secili.closest('[data-hop-frame-type]').getAttribute('data-hop-frame-type') : null;
  }

  function tazele(kok) {
    var tablar = kok.querySelector('[data-hop-type-tabs]');
    var alan = kok.querySelector('[data-hop-frame-fieldset]');
    if (!tablar || !alan) return;

    var tip = seciliTip(alan);

    tablar.querySelectorAll('.hop-type-tab').forEach(function (t) {
      var benim = t.getAttribute('data-hop-type') === tip;
      t.classList.toggle('is-active', benim);
      t.setAttribute('aria-pressed', benim ? 'true' : 'false');
    });

    // The tab filters the list: CSS keys off this attribute to drop every card
    // outside the active group, so Framed Print shows frames only and Canvas
    // shows canvas finishes only.
    if (tip) {
      alan.setAttribute('data-hop-active-type', tip);
    } else {
      alan.removeAttribute('data-hop-active-type');
    }

    // The frame list is only meaningful when there is more than one frame to
    // choose between — on Print there is nothing to pick, so it stays hidden,
    // as it does in the reference.
    var grupSayisi = kartlar(alan).filter(function (k) {
      return k.getAttribute('data-hop-frame-type') === tip;
    }).length;
    alan.hidden = tip !== null && grupSayisi < 2;

    // Size hint follows the tab, as the reference's pdSetType does. Written
    // only when it changes: this runs from a childList observer, and a
    // same-text write would still swap the text node and re-trigger it.
    var ipucu = kok.querySelector('[data-hop-size-hint]');
    if (ipucu) {
      var metin = ipucu.getAttribute(tip === 'canvas' ? 'data-hint-canvas' : 'data-hint-default');
      if (metin && ipucu.textContent !== metin) ipucu.textContent = metin;
    }

    boyutlariSuz(kok, alan, tip);
  }

  // Parses the picker's variant table and reads the current selection: one
  // value per option, in option order (document order of the selects and
  // checked radios is exactly that order), plus which of them is the finish.
  function durumOku(vs, alan) {
    var veriEl = vs && vs.querySelector('[data-hop-variants]');
    if (!veriEl) return null;
    var varyantlar;
    try {
      varyantlar = JSON.parse(veriEl.textContent);
    } catch (err) {
      return null;
    }
    var girdiler = Array.prototype.slice.call(
      vs.querySelectorAll('select[name^="options["], input[type="radio"]:checked')
    );
    var finishIdx = -1;
    girdiler.forEach(function (el, i) {
      if (alan.contains(el)) finishIdx = i;
    });
    if (finishIdx === -1) return null;
    return {
      varyantlar: varyantlar,
      girdiler: girdiler,
      finishIdx: finishIdx,
      secim: girdiler.map(function (el) {
        return el.value;
      }),
    };
  }

  /* On Framed Print and Canvas, a size the group does not come in is greyed
     out in the dropdown (the reference lists only the canvas sizes on
     Canvas). Picking one used to drop the shopper silently back to a print.
     Print lists every size. Only options this script disabled are re-enabled,
     and the selected size is never disabled. */
  function boyutlariSuz(kok, alan, tip) {
    var vs = kok.matches && kok.matches('variant-selects') ? kok : kok.querySelector('variant-selects');
    var d = durumOku(vs, alan);
    if (!d) return;
    d.girdiler.forEach(function (sec, i) {
      if (i === d.finishIdx || sec.tagName !== 'SELECT') return;
      Array.prototype.forEach.call(sec.options, function (o) {
        var kapat =
          tip !== null &&
          tip !== 'plain' &&
          !o.selected &&
          !d.varyantlar.some(function (v) {
            return (
              v.a &&
              tipi(v.o[d.finishIdx]) === tip &&
              v.o.every(function (deger, j) {
                if (j === d.finishIdx) return true;
                return j === i ? deger === o.value : deger === d.secim[j];
              })
            );
          });
        if (kapat && !o.disabled) {
          o.disabled = true;
          o.setAttribute('data-hop-kapali', '');
        } else if (!kapat && o.hasAttribute('data-hop-kapali')) {
          o.disabled = false;
          o.removeAttribute('data-hop-kapali');
        }
      });
    });
  }

  // Formats cents like a sample money string from the same shop ("$14.79",
  // "€14,79", "¥1,479"): the sample's separators and symbol are reused, so
  // the instant card price matches what the server prints a moment later.
  function paraYaz(kurus, ornek) {
    var m = /\d(?:[\d.,']*\d)?/.exec(ornek || '');
    if (!m) return ((kurus / 100).toFixed(2));
    var sayi = m[0];
    var ondalik = /[.,]\d{2}$/.test(sayi) ? sayi.charAt(sayi.length - 3) : null;
    var binlik = sayi.indexOf("'") !== -1 ? "'" : ondalik === ',' ? '.' : ',';
    var parca = ondalik ? (kurus / 100).toFixed(2).split('.') : [String(Math.round(kurus / 100))];
    var tam = parca[0].replace(/\B(?=(\d{3})+(?!\d))/g, binlik);
    return ornek.replace(sayi, ondalik ? tam + ondalik + parca[1] : tam);
  }

  /* Recomputes every card's availability and price difference from the
     variant table for the CURRENT selection. The cards are server-rendered
     for the previous size, so switching to Canvas from 5 x 7 (no canvas
     there) moved the size to 8 x 10 but left all four canvas cards struck
     through as unavailable until Dawn's re-render arrived. Same base rule as
     the Liquid: cheapest available of the canvas group on Canvas, of the
     print otherwise. */
  function kartlariHesapla(alan, d) {
    var tip = tipi(d.secim[d.finishIdx]);
    var tabanTipi = tip === 'canvas' ? 'canvas' : 'plain';
    var buBoyutta = d.varyantlar.filter(function (v) {
      return v.o.every(function (deger, i) {
        return i === d.finishIdx || deger === d.secim[i];
      });
    });
    var mevcut = buBoyutta.filter(function (v) {
      return v.a;
    });
    var enUcuz = function (liste) {
      return liste.reduce(function (en, v) {
        return en === null || v.n < en ? v.n : en;
      }, null);
    };
    var taban = enUcuz(
      mevcut.filter(function (v) {
        return tipi(v.o[d.finishIdx]) === tabanTipi;
      })
    );
    if (taban === null) taban = enUcuz(mevcut);
    var ornek = mevcut.length ? mevcut[0].p : '';
    var dahil = alan.getAttribute('data-hop-label-included') || '';
    var yok = alan.getAttribute('data-hop-label-unavailable') || '';

    alan.querySelectorAll('.hop-frame-card').forEach(function (kart) {
      var radyo = kart.querySelector('input[type="radio"]');
      var fiyat = kart.querySelector('.hop-frame-card__price');
      if (!radyo || !fiyat) return;
      var v = buBoyutta.filter(function (x) {
        return x.o[d.finishIdx] === radyo.value;
      })[0];
      var varMi = !!(v && v.a);
      kart.classList.toggle('is-unavailable', !varMi);
      if (!varMi) {
        fiyat.classList.remove('is-included');
        if (fiyat.textContent.trim() !== yok) fiyat.textContent = yok;
        return;
      }
      if (taban === null || typeof v.n !== 'number') return;
      var fark = v.n - taban;
      var metin = fark === 0 ? dahil : '+' + paraYaz(fark, ornek);
      fiyat.classList.toggle('is-included', fark === 0);
      if (fiyat.textContent.trim() !== metin) fiyat.textContent = metin;
    });
  }

  function tipi(deger) {
    var d = String(deger).toLowerCase();
    if (d.indexOf('canvas') !== -1) return 'canvas';
    if (d.indexOf('frame') !== -1) return 'framed';
    return 'plain';
  }

  // Picks the available variant in the requested group whose size is nearest
  // the current one (larger first, then smaller) and selects both its size
  // and its finish in one change, so Dawn re-renders once, on a real variant.
  function enYakinaGec(kok, alan, istenen) {
    var vs = kok.closest ? kok.closest('variant-selects') || kok.querySelector('variant-selects') : null;
    if (!vs) return false;
    var veriEl = vs.querySelector('[data-hop-variants]');
    if (!veriEl) return false;
    var varyantlar;
    try {
      varyantlar = JSON.parse(veriEl.textContent);
    } catch (err) {
      return false;
    }
    // Same order the instant-price listener uses: selects and checked radios
    // in document order are the options in option order.
    var girdiler = Array.prototype.slice.call(
      vs.querySelectorAll('select[name^="options["], input[type="radio"]:checked')
    );
    var finishIdx = -1;
    girdiler.forEach(function (el, i) {
      if (alan.contains(el)) finishIdx = i;
    });
    var secim = girdiler.map(function (el) {
      return el.value;
    });
    var boyutSec = girdiler.filter(function (el, i) {
      return i !== finishIdx && el.tagName === 'SELECT';
    })[0];
    if (finishIdx === -1 || !boyutSec) return false;
    var sizeIdx = girdiler.indexOf(boyutSec);
    var sira = Array.prototype.map.call(boyutSec.options, function (o) {
      return o.value;
    });
    var simdiki = sira.indexOf(secim[sizeIdx]);
    var finishSira = Array.prototype.map.call(alan.querySelectorAll('input[type="radio"]'), function (r) {
      return r.value;
    });

    var aday = varyantlar
      .filter(function (v) {
        return v.a && tipi(v.o[finishIdx]) === istenen;
      })
      .map(function (v) {
        var i = sira.indexOf(v.o[sizeIdx]);
        return {
          v: v,
          uzaklik: i >= simdiki ? i - simdiki : 1000 + (simdiki - i),
          fsira: finishSira.indexOf(v.o[finishIdx]),
        };
      })
      .sort(function (a, b) {
        return a.uzaklik - b.uzaklik || a.fsira - b.fsira;
      })[0];
    if (!aday) return false;

    // Dawn reads the select through the `selected` ATTRIBUTE, not the
    // property, so both move.
    Array.prototype.forEach.call(boyutSec.options, function (o) {
      var bu = o.value === aday.v.o[sizeIdx];
      o.selected = bu;
      if (bu) o.setAttribute('selected', 'selected');
      else o.removeAttribute('selected');
    });
    var radyo = Array.prototype.filter.call(alan.querySelectorAll('input[type="radio"]'), function (r) {
      return r.value === aday.v.o[finishIdx];
    })[0];
    if (!radyo) return false;
    radyo.checked = true;
    radyo.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  // Changing the SIZE to one the chosen finish does not come in (Canvas at
  // A0) used to land on "Unavailable". Before Dawn reads the selection (this
  // runs in the capture phase, ahead of variant-selects' own listener), the
  // finish moves to the first available one in the same group — or, if the
  // group has nothing at that size, the first available at all (the print).
  document.addEventListener(
    'change',
    function (e) {
      var sec = e.target;
      if (!sec || sec.tagName !== 'SELECT') return;
      var vs = sec.closest('variant-selects');
      var alan = vs && vs.querySelector('[data-hop-frame-fieldset]');
      var veriEl = vs && vs.querySelector('[data-hop-variants]');
      if (!alan || !veriEl) return;
      var varyantlar;
      try {
        varyantlar = JSON.parse(veriEl.textContent);
      } catch (err) {
        return;
      }
      var girdiler = Array.prototype.slice.call(
        vs.querySelectorAll('select[name^="options["], input[type="radio"]:checked')
      );
      var finishIdx = -1;
      girdiler.forEach(function (el, i) {
        if (alan.contains(el)) finishIdx = i;
      });
      if (finishIdx === -1) return;
      var secim = girdiler.map(function (el) {
        return el.value;
      });
      function uyar(v, finish) {
        return v.a && v.o.every(function (d, i) {
          return i === finishIdx ? d === finish : d === secim[i];
        });
      }
      if (varyantlar.some(function (v) { return uyar(v, secim[finishIdx]); })) return;

      var radyolar = Array.prototype.slice.call(alan.querySelectorAll('input[type="radio"]'));
      var grup = tipi(secim[finishIdx]);
      var yedek =
        radyolar.filter(function (r) {
          return tipi(r.value) === grup && varyantlar.some(function (v) { return uyar(v, r.value); });
        })[0] ||
        radyolar.filter(function (r) {
          return varyantlar.some(function (v) { return uyar(v, r.value); });
        })[0];
      if (yedek) yedek.checked = true;
    },
    true
  );

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.hop-type-tab');
    if (!tab) return;
    var kok = tab.closest('variant-selects, .product__info-container') || document;
    var alan = kok.querySelector('[data-hop-frame-fieldset]');
    if (!alan) return;

    var istenen = tab.getAttribute('data-hop-type');
    var grup = kartlar(alan).filter(function (k) {
      return k.getAttribute('data-hop-frame-type') === istenen;
    });
    var hedef = grup.filter(function (k) {
      return !k.classList.contains('is-unavailable');
    })[0];
    // The group has nothing at this size (5 x 7 has no canvas, A0 comes as a
    // print only): move to the nearest size that has it instead of landing on
    // "Unavailable" — the Etsy listing behaves the same way, the client asked
    // for it ("olanlar sectiginiz zaman cikiyor").
    if (!hedef && enYakinaGec(kok, alan, istenen)) return;
    hedef = hedef || grup[0];
    if (!hedef) return;

    var girdi = hedef.querySelector('input');
    if (girdi && !girdi.checked) girdi.click();
    tazele(kok);
  });

  /* Instant feedback. The ring and the price used to wait for Dawn's section
     re-render, a full server round trip per click (measured 428 ms before the
     ring moved). Both are known the moment the shopper clicks — the picker
     carries every variant's options and price — so they update now, and the
     server response lands on the same values a moment later. */
  document.addEventListener('change', function (e) {
    var vs = e.target.closest('variant-selects');
    if (!vs) return;

    var kart = e.target.closest('.hop-frame-card');
    if (kart && kart.parentElement) {
      kart.parentElement.querySelectorAll('.hop-frame-card').forEach(function (k) {
        k.classList.toggle('is-selected', k === kart);
      });
    }

    var veriEl = vs.querySelector('[data-hop-variants]');
    if (!veriEl) return;
    var varyantlar;
    try {
      varyantlar = JSON.parse(veriEl.textContent);
    } catch (err) {
      return;
    }

    // Cards, tabs, hint and size list for the new selection, now rather than
    // after the server round trip (this also covers enYakinaGec's jump).
    var alan = vs.querySelector('[data-hop-frame-fieldset]');
    if (alan) {
      var d = durumOku(vs, alan);
      if (d) kartlariHesapla(alan, d);
      tazele(vs);
    }

    // One value per option, in option order: document order of the picker's
    // selects and checked radios is exactly that order.
    var secim = Array.prototype.map.call(
      vs.querySelectorAll('select[name^="options["], input[type="radio"]:checked'),
      function (el) {
        return el.value;
      }
    );
    var eslesen = varyantlar.filter(function (v) {
      return (
        v.o.length === secim.length &&
        v.o.every(function (deger, i) {
          return deger === secim[i];
        })
      );
    })[0];
    if (!eslesen) return;

    var fiyatKabi = document.getElementById('price-' + vs.dataset.section);
    if (!fiyatKabi) return;
    // A variant on sale shows .price__sale (Dawn hides .price__regular under
    // .price--on-sale), so writing only the regular price left Etsy-style
    // listings — every Brighton variant has a compare-at — on the old price
    // until the re-render. Both blocks, the struck-through compare-at and the
    // on-sale state move together.
    fiyatKabi.querySelectorAll('.price__regular .price-item--regular:not(s), .price__sale .price-item--sale').forEach(function (el) {
      el.textContent = eslesen.p;
    });
    if (eslesen.c) {
      fiyatKabi.querySelectorAll('.price__sale s.price-item--regular').forEach(function (el) {
        el.textContent = eslesen.c;
      });
    }
    fiyatKabi.querySelectorAll('.price').forEach(function (el) {
      el.classList.toggle('price--on-sale', !!eslesen.c);
    });
  });

  // Dawn swaps the picker's markup after each variant change.
  new MutationObserver(function () {
    document.querySelectorAll('variant-selects, .product__info-container').forEach(tazele);
  }).observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('variant-selects, .product__info-container').forEach(tazele);
})();
